module.exports = __webpack_public_path__ + "img/flag-DO.d92e95e1.png";